import { Injectable } from '@angular/core';
import { environment as config } from '../../../environments/environment';
import { AuthHttp } from 'angular2-jwt';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AuthService } from '../auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BasicService } from '../../providers/basic';

@Injectable()
export class PaymentService extends BasicService {
  private baseUrl: string = config.payment.url;
  public credits$: BehaviorSubject<number> = new BehaviorSubject(0);

  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(auth, translate);
    this.find().subscribe(({ amount }) => this.credits$.next(amount));
  }

  private find() {
    return this.http
      .get(`${this.baseUrl}/credits`)
      .map(response => response.json())
      .catch(err => this.handleError(err));
  }

  public decrease(amount) {
    return this.http
      .post(`${this.baseUrl}/credits/decrease`, { amount })
      .map(response => response.json())
      .do(({ amount }) => this.credits$.next(amount))
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/payment/payment.service.ts